module.exports = __webpack_public_path__ + "img/vlovemother-banner-wap.287b0c23.jpg";